var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scroll-pane", [
    _vm.activeEvent
      ? _c(
          "div",
          { attrs: { slot: "scroll" }, slot: "scroll" },
          [
            _c("state-inspector", {
              attrs: { state: { "event info": _vm.sortedEventData } }
            })
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "no-event-data",
            attrs: { slot: "scroll" },
            slot: "scroll"
          },
          [_vm._v("\n    No event selected\n  ")]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }